import React from 'react';
import Layout from '../../components/Layout/Layout';
import NotFound from '../../components/NotFound/NotFound';
import ViewTracking from './ViewTracking';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import { getBooking } from '../../actions/booking/getBooking';

async function action({ params, store, query }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;
    const id = Number(params?.id);

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
        return { redirect: '/' }
    }

    await store.dispatch(getBooking(id));

    let bookingDetails = store.getState().bookingDetails?.data;
    const isBookingAvailable = ['declined', 'cancelledByUser', 'cancelledByPartner', 'expired', 'scheduled'].includes(bookingDetails?.status);

    // Genuinely missing booking → 404. But a booking that simply isn't a LIVE/trackable job anymore
    // (completed/reviewed/cancelled/expired/scheduled) should go to its detail page (invoice/history),
    // not a 404 — e.g. opening /tracking/:id for a finished job.
    if (!bookingDetails) {
        return {
            title,
            component: (
                <Layout>
                    <NotFound title={'Page Not Found'} />
                </Layout>
            ),
        };
    }
    if (isBookingAvailable || bookingDetails?.isReviewPageVisited) {
        return { redirect: '/booking/' + id };
    }

    return {
        title,
        description,
        component: (
            <Layout>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <ViewTracking id={id} />
                </div>
            </Layout>
        ),
    };
}

export default action;